<template>
<div class="process-forms">
    <el-form size="mini" label-width="120px">
        <el-row v-if="!isFormCardModel">
          <el-col :span="12">
                <el-form-item label="流程实例名称" >
                    <el-input  disabled v-model="processInfo.instanceName" />
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="流程模板">
                    <el-input disabled v-model="processInfo.serviceName"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <div class="form-content">
            <el-tabs v-if="isShowForms" type="border-card" v-model="collapseActiveName" @tab-click="handleChange">
              <el-tab-pane v-for="(form, index) in forms" :key="taskData[index].id" :label="taskData[index].titleName" :name="taskData[index].id">
                <span slot="label">
                  <div class='el-collapse-title'>
                      <span :title="taskData[index].formName">{{taskData[index].titleName}}</span>
                      <el-button size="mini" icon="el-icon-printer" title='打印' @click.stop="handlePrint(index)"></el-button>
                  </div>
                </span>
                 <el-form :model="currentFormData.values" label-width="165px" :ref="'customForm'+index" >
                    <div :key="loadTimerField" >
                        <template v-for="(field,index2) in form.fieldsList" >
                            <FieldItem 
                                :findex="index2" 
                                :formId="form.id"  
                                :formConfig="form" 
                                :key="field.fieldId" 
                                :ref="'fieldItemChild'+index2"
                                :field="field" 
                                :formData="currentFormData.values" 
                                :colSpan="form.colSpan" 
                                :fieldsList="form.fieldsList"
                                @refreshViewField="refreshViewField"
                            />
                        </template>
                        <!-- 关联的其他表单数据 add by hezhen 20210327    start-->
                        <div class="render-form-item" v-if="showRelateFormTab" style="width: 100%; float: left;">
                                  <el-row>
                                      <el-form-item class="relateFormTab" label="" style="width: 100%;">
                                      <el-tabs :key="loadTimerRelate" @tab-click="handleRelateFormTabClick(form)" v-model="relateFormTabName" >
                                          <template v-for="(model, index3) in form.relateModelList" >
                                              <el-tab-pane :key="model.id" :label="model.modelName" :name="model.id" v-if="!model.hiddenElement && isShowSonForm(form.relateModelViewIds,model.id)">
                                                  <RelateFormList
                                                      :ref="'relateModelList' + model.id"
                                                      :key="loadTimerRelate"
                                                      :selectedModel="model"
                                                      :tempFormData="tempFormData"
                                                      :parentFormInfo="formInfo"
                                                      :parentFormData="formData"
                                                      :viewData="true"
                                                  />
                                              </el-tab-pane>
                                          </template>
                                      </el-tabs>
                                      </el-form-item>
                                  </el-row>
                              </div>
                        <!-- 关联的其他表单数据 add by hezhen 20210327    end-->
                    </div>
                </el-form>
              </el-tab-pane>
            </el-tabs>
        </div>
    </el-form>
    <el-dialog 
        title="打印确认页"
        append-to-body
        top="4vh"
        :fullscreen=true
        :visible.sync="isShowPrintUtil">
        <PrintUtil :key="loadTimer" ref="printUtil" :formInfo="printForm"  />
    </el-dialog> 
</div>
</template>

<script>
    import { isEmpty } from 'lodash';
    import { getUserList, getProcessAllFormInstances } from '@/data-model';
    import PrintUtil from '@/components/PrintUtil';
    import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
    
    export default {
        components: {
            PrintUtil,
            RelateFormList
        },
        data () {
            return {
                defaultViewOrder: null,
                loadTimerField: '',
                isShowForms: false,
                collapseActiveName: '',
                currentIndex: 0, // 当前是第几个表单，默认是0
                currentFormData: {}, // 当前表单的表单的值
                formData: [], // 存储各个表单的值
                taskData: [], // 存储表单的表名、id等信息
                isShowPrintUtil: false,
                loadTimer: '',
                printForm: {},
                loadTimerRelate: '',
                relateFormTabName: '',
                showRelateFormTab: false,
                tempFormData: [], // 将要新增的关联表单数据
                formInfo: {
                    formObj: {}
                }
            };
        },
        props: {
            processInfo: {
                type: Object
            },
            isFormCardModel: {// 是否表单卡片显示模式
                type: Boolean,
                default: false
            },
            cardFormId: {
                type: String,
                default: null
            },
            cardInstanceId: {
                type: String,
                default: null
            }
        },
        computed: {
            forms () {
                if (isEmpty(this.processInfo.formObj)) {
                    return [];
                } else {
                    if (this.processInfo.formObj.structure[0].relateModelList && this.processInfo.formObj.structure[0].relateModelList.length > 0) {
                        let cur = this.processInfo.formObj.structure[0];
                        this.relateFormTabName = this.processInfo.formObj.structure[0].relateModelList[0].id;
                        this.formInfo.formId = cur.id;
                        this.showRelateFormTab = true;
                        let formObj = {
                            structure: [{
                                modelName: cur.modelName,
                                appName: cur.appName,
                                remarks: cur.remarks,
                                modelType: cur.modelType,
                                fieldsList: cur.fieldsList
                            }]
                        };
                        this.formInfo.formObj = formObj;
                        this.showRelateFormTab = true;
                    }
                    return this.processInfo.formObj.structure;
                }
            }
        },
        mounted () {
            // this.$nextTick(() => {
            //     this.initFormPage();
            // });
        },
        created () {
            this._initFormsData();
            // this.queryUserList("");
        },
        methods: {
            // 初始化表单结构
            async initFormPage () {
                if (!isEmpty(this.forms)) {
                    let formInfo = this.forms[0];// 默认第一个
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        this.loadTimerField = new Date().getTime();
                        let initUserArr = [];
                        for (var i = 0; i < formInfo.fieldsList.length; i++) {
                            let tempField = formInfo.fieldsList[i];
                            let tempRefName = 'fieldItemChild' + i;
                            if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                                setTimeout(() => {
                                // 设置下拉字段级联默认显示数据
                                    if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                        this.$refs[tempRefName][0].initDefaultCasData();
                                    }
                                }, 0);
                            }
                            if ((!this.defaultViewOrder || this.defaultViewOrder !== 0) && tempField.type === 'subform') { // 用来显示默认第一个子表单
                                this.defaultViewOrder = i + '';
                            }
                            if (tempField.type === 'user') {
                                initUserArr.push(tempRefName);
                            }
                        }
                        for (var j = 0; j < initUserArr.length; j++) { // 针对人员级联初始化
                            let tempRefName = initUserArr[j];
                            setTimeout(async () => {
                                // 设置下拉字段级联默认显示数据
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    await this.$refs[tempRefName][0].setUserExtCascadeData(true);
                                }
                            }, 0);
                        }
                    }
                }
            },
            async _initFormsData (id) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.isShowForms = false;
                // let tempFormsObj = await getProcessModelForms({
                let tempFormsObj = await getProcessAllFormInstances({
                    processInstanceId: this.processInfo.processInstanceId,
                    deploymentId: this.processInfo.deploymentId,
                    isFormCardModel: this.isFormCardModel,
                    cardFormId: this.cardFormId,
                    cardInstanceId: this.cardInstanceId
                });
                let structure = [];
                this.processInfo.formObj = {};
                this.processInfo.formObj.structure = [];
                // console.log(tempFormsObj);
                let formValMap = new Map();
                let formObjMap = new Map();
                if (tempFormsObj && Array.isArray(tempFormsObj)) {
                    // structure=tempFormsObj[0].structure;
                    let isHasVal = false;
                    let taskIdx = 0;
                    tempFormsObj.forEach(taskForm => {
                        let formIdx = 0;
                        let objModelFormInstance = this._getTemporaryFormInstance(taskForm);
                        if (objModelFormInstance) {
                            objModelFormInstance.forEach(form => {
                                // console.log(tempFormsObj[taskIdx].structure[formIdx]);
                                // this.formData.push(form);
                                formValMap.set(form.formId, form);
                                isHasVal = true;
                            });
                        }
                        let objModelFormStructure = taskForm.structure;
                        // console.log(objModelFormStructure);
                        if (objModelFormStructure) {
                            objModelFormStructure.forEach(form => {
                                let temFormName = '任务' + (taskIdx + 1) + '【' + taskForm.taskName + '】-表单' + (formIdx + 1) + '【' + tempFormsObj[taskIdx].structure[formIdx].formName + '】';
                                let titleName = '【' + tempFormsObj[taskIdx].structure[formIdx].formName + '】';
                                // console.log(formValMap.get(form.id));
                                let instanceId = '';
                                if (formValMap.get(form.id)) {
                                    instanceId = formValMap.get(form.id).values.id ? formValMap.get(form.id).values.id : (formValMap.get(form.id).modelInstanceId ? formValMap.get(form.id).modelInstanceId : '');
                                }
                                // console.log(instanceId);
                                // console.log(formObjMap.has(instanceId));
                                let isDelete = '0';
                                if (formValMap.has(form.id)) {
                                    if (!formObjMap.has(instanceId) || instanceId === '') {
                                        if (!isEmpty(instanceId) && !formObjMap.has(instanceId)) {
                                            let formValue = formValMap.get(form.id);
                                            // console.log(formValue);
                                            isDelete = formValue.values.isDelete;
                                            // console.log(isDelete);
                                            if (isDelete === '0') {
                                                this.formData.push(formValMap.get(form.id));
                                                this.taskData.push({titleName: titleName, formName: temFormName, id: form.id + taskIdx + formIdx});
                                            }
                                        } else {
                                            this.formData.push(formValMap.get(form.id));
                                            this.taskData.push({titleName: titleName, formName: temFormName, id: form.id + taskIdx + formIdx});
                                        }
                                    }
                                } else {
                                    this.initDefaultVal(form);
                                    this.taskData.push({titleName: titleName, formName: temFormName, id: form.id + taskIdx + formIdx});
                                }
                                if (!formObjMap.has(instanceId) || instanceId === '') {
                                    if (isDelete === '0') {
                                        structure.push(form);
                                        formObjMap.set(instanceId, instanceId);
                                    }
                                }
                                formIdx++;
                            });
                        }
                        taskIdx++;
                    });
                    if (!isHasVal) {
                        await this.initAllDefaultVal(structure);
                    }
                    this.processInfo.formObj.structure = structure;
                    this.collapseActiveName = this.taskData.length > 0 ? this.taskData[0].id : '';
                    if (this.formData.length > 0) {
                        this.isShowForms = true;
                        this.$nextTick(() => {
                            this.initFormPage();
                        });
                        this.currentFormData = this.formData[0];// 默认显示第一个表单的值
                    }
                }
                loading.close();
                // console.log(this.forms);
                // console.log(this.formData);
                //  if (objModelFormData && Array.isArray(objModelFormData)) {
                //     objModelFormData.forEach(form => {
                //         this.formData.push(form);
                //     });
                // }else{
                //     this.formData.push(objModelFormData);
                // }
                this.loadTimerField = new Date().getTime();
                if(this.forms[0].relateModelViewIds){
                    this.forms[0].relateModelList.forEach(item => { 
                        if(this.forms[0].relateModelViewIds.indexOf(item.id)>-1){
                            this.relateFormTabName = item.id;
                        }
                    });
                    setTimeout(() => { // 等待dom渲染完成
                        this.handleRelateFormTabClick(this.forms[0]);
                    },500)
                }
            },
            async initAllDefaultVal (structure) {
                structure.forEach(element => {
                    this.initDefaultVal(element);
                });
            },
            // 表单没有值，初始化为默认值
            async initDefaultVal (element) {
                // console.log('this.forms.forEach');
                let fieldsList = element.fieldsList;
                let values = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    values[element.id] = '';
                }
                this.formData.push({
                    formId: element.id,
                    values: values,
                    colSpan: element.colSpan ? element.colSpan : 1,
                    ext1: element.ext1 ? Number(element.ext1) : 0
                });
            },
            _getTemporaryFormInstance (sourceForms) {
                let temporaryFormData;
                if (sourceForms && sourceForms.instance) {
                    try {
                        let strTemporaryData = sourceForms.instance;
                        let objTemporaryData = JSON.parse(strTemporaryData);
                        temporaryFormData = objTemporaryData;
                    } catch (error) {
                        console.error('解析任务表单数据异常：', error);
                    }
                }
                return temporaryFormData;
            },
            async queryUserList (userName) {
                this.loading = true;
                let userData = await getUserList({ name: userName });
                this.userList = userData.data;
                this.loading = false;
            },
            handleChange (tab) {
                let tabName = tab.name; // form.id + taskIdx + formIdx
                for (let i = 0; i < this.taskData.length; i++) {
                    let item = this.taskData[i];
                    if (item.id === tabName) {
                        this.currentIndex = i;
                        break;
                    }
                }
                this.currentFormData = this.formData[this.currentIndex];
                let arr = this.processInfo.formObj.structure;
                if (arr && arr.length > 0) { // 切换页签的时候判断是否有子表单
                    for (let i = 0; i < arr.length; i++) {
                        let cur = arr[i];
                        if (cur.id === this.currentFormData.formId) {
                            if (cur.relateModelList && cur.relateModelList.length > 0) { // 拥有关联子表
                                this.relateFormTabName = cur.relateModelList[0].id;
                                this.formInfo.formId = cur.id;
                                let formObj = {
                                    structure: [{
                                        modelName: cur.modelName,
                                        appName: cur.appName,
                                        remarks: cur.remarks,
                                        modelType: cur.modelType,
                                        fieldsList: cur.fieldsList
                                    }]
                                };
                                this.formInfo.formObj = formObj;
                                this.handleRelateFormTabClick(cur);
                                this.showRelateFormTab = true;
                            }
                        }
                    }
                }
            },
            // handlePrint (index) {
            //     this.$print(this.$refs['customForm' + index]);
            // }
            handlePrint (index) {
                this.loadTimer = new Date().getTime();
                this.printForm = this.formData[index];
                this.printForm.fieldsList = this.forms[index].fieldsList;
                this.printForm.formName = this.forms[index].formName;
                this.isShowPrintUtil = true;
            },
            refreshViewField () {
                this.loadTimerField = new Date().getTime();
            },
            async handleRelateFormTabClick (tab, event) {
                for (var i = 0; i < tab.relateModelList.length; i++) {
                    let model = tab.relateModelList[i];
                    if (model.id === this.relateFormTabName) {
                        this.renderModelFormList(model);
                    }
                }
            },
            async renderModelFormList (model) {
                // if (this.relateModelMap && this.relateModelMap.has(model.id)) {
                //     this.showRelateFormTab = this.relateModelMap.get(model.id);
                // }
                // if (this.showRelateFormTab) {
                // 主表的formid
                model.mainFormId = this.formInfo.formId;
                // 主表当前数据id
                model.mainFormDataId = this.currentFormData.values.id;
                // this.loadTimerRelate = new Date().getTime();
                this.$nextTick(() => {
                    if (this.$refs['relateModelList' + model.id] && this.$refs['relateModelList' + model.id].length > 0) {
                        this.$refs['relateModelList' + model.id][0].renderFormList(model);
                    }
                });
                // }
            },
            isShowSonForm(relateModelViewIds,id){
                if(relateModelViewIds && relateModelViewIds.indexOf(id) > -1){//勾选了子表单才能可见
                    return true;
                }else{
                    return false;
                }
            }
        }
    };
</script>
<style lang="less">
  .process-forms {
     margin-top: -30px;
    .el-collapse-title {
        color: #4ebe17;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > .el-button {
            margin-right: 10px;
        }
    }
    .form-content{
      .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
        margin-bottom:2px
      }
      .el-form-item__label{
        color: #333;
        font-weight: 700;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/ProcessForms.vue